import React from "react";
import { Box, Typography, useTheme, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import NationalLogo from "../Assets/MinistryAFWW-White.png";
import NamaLogo from "../Assets/nama-logo.png";
import SupportedBy from "../Assets/supportedby.png";

const SubHeader = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isExtraSmall = useMediaQuery("(max-width:400px)");

  return (
    <Box sx={{ py: { xs: 1.5, sm: 2 }, px: { xs: 1, sm: 2, md: 3 } }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
          flexDirection: "row",
          gap: { xs: 0.5, sm: 1, md: 2 },
          mx: { xs: "auto", sm: 0 },
          mb: { xs: 1, sm: 2 },
          maxWidth: "100%",
          borderRadius: 2,
          overflow: "hidden",
        }}
      >
        {/* Under Patronage Section */}
        <SectionBox>
          <SectionTypography>{t("underPatronage")}</SectionTypography>
          <LogoImage
            src={NationalLogo}
            alt="Sultanate of Oman"
            style={{
              height: isMobile ? "70px" : "80px",
              maxHeight: isExtraSmall ? "60px" : undefined,
            }}
          />
        </SectionBox>

        {/* Supported By Section */}
        <SectionBox>
          <SectionTypography>
            {t("supportedBy") || "Supported By"}
          </SectionTypography>
          <LogoImage
            src={SupportedBy}
            alt="Supported By"
            style={{
              height: isMobile ? "70px" : "80px",
              maxHeight: isExtraSmall ? "60px" : undefined,
            }}
          />
        </SectionBox>

        {/* Hosted By Section - No right border */}
        <SectionBox hasBorder={false}>
          <SectionTypography>{t("hostedBy")}</SectionTypography>
          <LogoImage
            src={NamaLogo}
            alt="Nama"
            style={{
              height: isMobile ? "70px" : "80px",
              maxHeight: isExtraSmall ? "60px" : undefined,
            }}
          />
        </SectionBox>
      </Box>
    </Box>
  );
};

// Component for consistent section boxes
const SectionBox = ({ children, hasBorder = true }) => (
  <Box
    sx={{
      textAlign: "center",
      flex: 1,
      position: "relative",
      px: { xs: 0.5, sm: 1, md: 2 },
      py: { xs: 1, sm: 1.5 },
      "&::after": hasBorder
        ? {
            content: '""',
            position: "absolute",
            right: 0,
            top: "15%",
            bottom: "15%",
            width: "1px",
            backgroundColor: "rgb(255, 255, 255)",
            display: "block",
          }
        : {},
    }}
  >
    {children}
  </Box>
);

// Component for consistent typography
const SectionTypography = ({ children }) => (
  <Typography
    variant="caption"
    sx={{
      fontSize: "clamp(0.65rem, 2vw, 0.9rem)",
      color: "#ffffff",
      opacity: 1,
      display: "block",
      mb: { xs: 0.5, sm: 1 },
      fontWeight: 500,
      letterSpacing: 0.1,
      wordSpacing: 1,
      textWrap: "nowrap",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
      textAlign: "center",
      width: "100%",
    }}
  >
    {children}
  </Typography>
);

// Component for consistent logo images
const LogoImage = ({ src, alt, style }) => (
  <img
    src={src}
    alt={alt}
    style={{
      maxWidth: "100%",
      objectFit: "contain",
      filter: "brightness(0) invert(1)",
      display: "block",
      margin: "0 auto",
      ...style,
    }}
  />
);

export default SubHeader;
